import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const LOCATIONS_POST_REQUEST = 'POST_LOCATIONS_REQUEST';
export const LOCATIONS_POST_FAILURE = 'POST_LOCATIONS_FAILURE';
export const LOCATIONS_POST_SUCCESS = 'POST_LOCATIONS_SUCCESS';

export const postLocations = (data) => {
    return function(dispatch) {
        dispatch(postLocationRequest());
        return axios(apiRequestOptions(apiPath.LOCATIONS.POST, data))
            .then(transformHttpResponse)
            .then(response => dispatch(postLocationSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postLocationFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postLocationRequest = () => {
    return {
        type: LOCATIONS_POST_REQUEST,
    }
};

const postLocationFailure = (error) => {
    return {
        type: LOCATIONS_POST_FAILURE,
        error,
    }
};

const postLocationSuccess = (location) => {
    return {
        type: LOCATIONS_POST_SUCCESS,
        location,
    }
};